// bundle set js
//bundle total price



$('document').ready(function(){
  var total = 0;
  var originaltotal = 0;
    $('.item_wrp').each(function(idx){
       var totalPc =parseFloat($(this).find('.product-bundle-item__content span').attr('data-id'));
       var totalCc =parseFloat($(this).find('.product-bundle-item__content span').attr('data-cprc'));
        total+= totalCc;
        originaltotal+= totalPc;
        
    });

  if(total){
    // console.log("12",total);
    $('.total_all_pdp span').text('£'+total.toFixed(2));
    $('.tot_item_price').text('£'+total.toFixed(2));
    
  }
  
  if(total > originaltotal){
     document.querySelector(".bundle_saving_prc").innerHTML = '£'+originaltotal.toFixed(2);
     document.querySelector(".bundle_saving_prc_crt").innerHTML = '£'+originaltotal.toFixed(2);
  }

    // var numVal1 = total;
    // var numVal2 = parseInt(document.getElementById("discount_bundle").innerText) / 100;
    // var totalValue = numVal1 - (numVal1 * numVal2);
    // console.log("totalval",totalValue);
    // document.querySelector(".bundle_saving_prc").innerHTML = '£'+totalValue.toFixed(2);
    // document.querySelector(".bundle_saving_prc_crt").innerHTML = '£'+totalValue.toFixed(2);
    

// bundle image change when change variant

$('.bundle_set_wrp .item_wrp').each(function(idx) {
  $('.item_'+ idx +' .ck_sel_variant').each( function() {
   
    $('#'+$(this).attr('id')).on('change', function(){
       var variant_img_src = $(this).find('option:selected').attr('data-image-id');
      //  console.log(variant_img_src);
       $('.item_'+ idx +' img').attr("src",variant_img_src);
    });
  });
});

// get selected radio value 
$('.bundle-product-form input[type=radio]').on('change', function() {
 
var price = $(this).attr("data-opt");
var val = $(this).attr("value");
$(this).closest('fieldset').find('[data-option-value]').text(val);
 //  console.log(price);
//console.log($("span." + price).text(val));
});

  
 
  $('#addToCartBtn').on('click',function(e){
    
    e.preventDefault();
    var variant_id = $('.variant_id_sel').attr("value"); 
    var bundle_set_title = $('.bundle_title_set').attr("value"); 
    var bundle_set_image = $('.bundle_image_set').attr("value"); 
    var bundle_set_price = $('.bundle_price_set').attr("value"); 
    var bundle_set_url = $('.bundle_url_set').attr("value"); 
    var bundle_set_cprice = $('.bundle_cprice_set').attr("value"); 
    let customTimeId = Date.now();
    var data = {'items': []};
    
   ////  console.log(variant_id);
    var quantity = $('.quantity__input').val();

  
    //Bundle set products

    
  
    $('.bundle_set_wrp .item_wrp').each(function(idx) {
        var checked_val = $(this).find('.ck_sel_variant').val();
        var BVal = checked_val;
       //  console.log(BVal);
        var Bqty = 1;
      
        //console.log(idx);
        if(typeof(BVal) != 'undefined'){
            if(idx == 0){
              data.items.push(
                  {
                    "id": BVal,
                    "quantity": Bqty,
                    "properties": {
                      '_set_id':`${customTimeId}`,
                      '_product_bundle_set': true,
                      '_bundle_set_idx': `${idx+1}`,
                      '_main_bundle_title':`${bundle_set_title}`,
                      '_main_bundle_price':`${Number(bundle_set_price)}`,
                      '_main_bundle_cprice':`${bundle_set_cprice ? `${Number(bundle_set_cprice)}` : `N/A`}`,
                      '_main_bundle_url':`${bundle_set_url}`,
                      '_main_bundle_image':`${bundle_set_image}`
                    }
                  }
                );
             //  console.log(data);
              }else{
                data.items.push(
                    {
                      "id": BVal,
                      "quantity": Bqty,
                      "properties": {
                        '_set_id':`${customTimeId}`,
                        '_bundle_set_idx': `${idx+1}`
                      }
                    });
                   //  console.log(data);
               }
          }else{
            //console.log('else');
          }
    }); 
      data.items = data.items.reverse();
     //  console.log(data);

      

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (cart) {
           (function(axios){
          axios
            .get(`${window.theme.routes.cart}.js`)
            .then((response) => {
              document.dispatchEvent(
                new CustomEvent('theme:cart:change', {
                  detail: {
                    cart: response.data,
                  },
                  bubbles: true,
                })
              );
            })
            .catch((e) => {
              console.error(e);
            });
        })(themeVendor.axios);
           
       
            document.addEventListener('theme:cart:change', (e) => {
              
              document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
                new CustomEvent('theme:drawer:open', {
                  bubbles: false,
                })
              );
          
            });
          
        },
        error: function (error) {
         //  console.log(error);
        },
      });
  });
});

class CarBundletRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let removeObj = {};
      let removeProKeys = this.closest('.ctm_qun_key').dataset.lineKey;
     //  console.log(removeProKeys);
      let removeProKeysSplited = removeProKeys.split(',');
      for(let i=0; i<removeProKeysSplited.length; i++){
        removeObj[removeProKeysSplited[i]] = 0;
      }
      const REMOVE_OBJ = { updates: removeObj };
      this.closest('line-item-updates').updateQuantity(REMOVE_OBJ,0);
    });
  }
}
customElements.define('bundle-remove-button', CarBundletRemoveButton);

class BundleCartItemsUpdates extends HTMLElement {
 
 constructor() {
    super();
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

  }

  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const previousValue = this.input.value;
    
    let updateObj = {};
    let updateProKeys = this.dataset.lineKey;
    let updateProKeysSplited = updateProKeys.split(',');
    let qtyLoader = 0;
    if(event.target.name === 'plus'){
      qtyLoader = Number(this.input.value)+1;
      for(let i=0; i<updateProKeysSplited.length; i++){
        updateObj[updateProKeysSplited[i]] = Number(this.input.value)+1;
      }
    }else{
      qtyLoader = Number(this.input.value)-1;
      for(let i=0; i<updateProKeysSplited.length; i++){
        updateObj[updateProKeysSplited[i]] = Number(this.input.value)-1;        
      }
    }
    const UPDATE_OBJ = { updates: updateObj };
    this.updateQuantity(UPDATE_OBJ,qtyLoader);
    
           
  }
updateQuantity(updateObj,qtyForLoader) {
   $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: updateObj,
        dataType: 'json',
        success: function (cart) {

          
              (function(axios){
              axios
                .get(`${window.theme.routes.cart}.js`)
                .then((response) => {
                  document.dispatchEvent(
                    new CustomEvent('theme:cart:change', {
                      detail: {
                        cart: response.data,
                      },
                      bubbles: true,
                    })
                  );
                })
                .catch((e) => {
                  console.error(e);
                });
            })(themeVendor.axios);
               
           
            document.addEventListener('theme:cart:change', (e) => {
                 document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }));
            });
           
          
             
        },
        error: function (error) {
         console.log(error);
        },
     
      });
          
         
           

  }
}
customElements.define('line-item-updates', BundleCartItemsUpdates);


var InputNumber = class extends HTMLInputElement {
    connectedCallback() {
      this.addEventListener("input", this._onValueInput.bind(this));
      this.addEventListener("change", this._onValueChanged.bind(this));
      this.addEventListener("keydown", this._onKeyDown.bind(this));
    }
    get quantity() {
      return parseInt(this.value);
    }
    set quantity(quantity) {
      const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
      if (quantity === "") {
        return;
      }
      if (!isNumeric || quantity < 0) {
        quantity = parseInt(quantity) || 1;
      }
      this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
      this.size = Math.max(this.value.length + 1, 2);
    }
    _onValueInput() {
      this.quantity = this.value;
    }
    _onValueChanged() {
      if (this.value === "") {
        this.quantity = 1;
      }
    }
    _onKeyDown(event) {
      event.stopPropagation();
      if (event.key === "ArrowUp") {
        this.quantity = this.quantity + 1;
      } else if (event.key === "ArrowDown") {
        this.quantity = this.quantity - 1;
      }
    }
  };
window.customElements.define("input-number", InputNumber, { extends: "input" });



// 
// 

// set the namespace for portability
// expand/collapse uses css transitions
// active = li that is open
// complete = li that has been opened and had next clicked
// current = last li that was open, not completed
jQuery(document).ready(function($) {
    $('.color_btn_ctm').attr('disabled','disabled');



	$('.steps-widget').on('click', '.btn-next', function(e) {
			e.preventDefault();
			//save reference to parent li for faster performance
			var li = $(this).closest('li');
    

      // if(($(li).next('li').index() + 1) == $('.steps-list > li').length){
      //    $('.color_btn_ctm').attr('disabled',false);
      // }
   
			
			if ($(li).next('li').length === 0) {
					// alert('submited');
                    $('.color_btn_ctm').attr('disabled',false);
                    $(li).addClass('complete').removeClass('active');
					return false;
			}
			
			$(li).prevAll().removeClass('current');
			// move to next step on next button click; add complete class to li
			$(li).addClass('complete').removeClass('active').next('li').addClass('active current');
			
	}).on('click', 'li.complete .label, li.current .label', function(e) {
			
			e.preventDefault();
			var li = $(this).closest('li');
			$(li).addClass('active').siblings('li.active').removeClass('active')
	})
});


// bundle quick view
 const throttle = (fn, wait) => {
    let prev, next;
    return function invokeFn(...args) {
      const now = Date.now();
      next = clearTimeout(next);
      if (!prev || now - prev >= wait) {
        // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        prev = now;
      } else {
        next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
      }
    };
  };
  function forceFocus(element, options) {
    options = options || {};

    element.focus();
    if (typeof options.className !== 'undefined') {
      element.classList.add(options.className);
    }
    element.addEventListener('blur', callback);

    function callback(event) {
      event.target.removeEventListener(event.type, callback);

      if (typeof options.className !== 'undefined') {
        element.classList.remove(options.className);
      }
    }
  }
 function focusable(container) {
    var elements = Array.prototype.slice.call(
      container.querySelectorAll('[tabindex],' + '[draggable],' + 'a[href],' + 'area,' + 'button:enabled,' + 'input:not([type=hidden]):enabled,' + 'object,' + 'select:enabled,' + 'textarea:enabled' + '[data-focus-element]')
    );

    // Filter out elements that are not visible.
    // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
    return elements.filter(function (element) {
      return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  var trapFocusHandlers = {};

  function trapFocus(container, options) {
    options = options || {};
    var elements = focusable(container);
    var elementToFocus = options.elementToFocus || container;
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (container !== event.target && !container.contains(event.target) && first && first === event.target) {
        first.focus();
      }

      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code !== 'Tab') return; // If not TAB key

      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    forceFocus(elementToFocus, options);
}
function removeTrapFocus() {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
}

const selectors$_ = {
  sizeButton: '[data-size-button]',
  mediaHolder: '[data-media-slide]',
};

const classes$C = {
  classExpanded: 'is-expanded',
};
class ImageCaption {
    constructor(container) {
      this.container = container;
      this.sizeButtons = this.container.querySelectorAll(selectors$_.sizeButton);

      if (this.sizeButtons.length > 0) {
        this.init();
      }
    }

    init() {
      this.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          button.classList.toggle(classes$C.classExpanded);
          button.closest(selectors$_.mediaHolder).classList.toggle(classes$C.classExpanded);
        });
      });
    }
  }

const selectors$Q = {
  dataQuickview: 'data-quickvieww',
  quickviewHolder: 'data-quickview-holder',
  addButtonWrapper: '[data-add-action-wrapper]',
  modalContent: '[data-bundle-product-quickview-ajax]',
  quickviewModal: '[data-quickview-modall]',
  quickviewModalScrolls: '[data-drawer-scrolls]',
  quickviewModalTemplate: '[data-quickview-modal-template]',
  quickviewHead: '[data-quickview-head]',
  quickviewFormArea: '[data-quickview-form-area]',
  toggleButton: '[data-toggle-button]',
  media: '[data-media-slide]',
  mediaId: '[data-media-id]',
  dataPopup: 'data-popup-',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
};
const classes$BQ = {
    hide: 'hide',
    active: 'is-active',
    expanded: 'is-expanded',
    loading: 'loading',
};
 const QvisibleParts = {
    minPart: 250,
    mediumPart: 400,
};
class BundleProductQuickView extends HTMLElement {
    constructor() {
      super();

      this.container = this;
    }

    static get observedAttributes() {
      return [selectors$Q.dataQuickview];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue) {
        this.disconnectedCallback();
        this.connectedCallback();
      }
    }

    connectedCallback() {
      this.quickviewHolder = this.container.querySelector(`[${selectors$Q.quickviewHolder}]`);
      this.modalCloseEvent = () => this.modalClose();
      this.clickQuickviewEvent = (e) => this.clickQuickviewButton(e);

      if (this.quickviewHolder) {
        this.modalTemplate = this.quickviewHolder.querySelector(selectors$Q.quickviewModalTemplate);
        this.modal = document.querySelector(selectors$Q.quickviewModal);
        this.modalID = this.quickviewHolder.getAttribute(selectors$Q.quickviewHolder);
        this.modalContent = null;
        this.modalScroll = null;
        this.scrollLockEnable = true;
        this.windowH = window.innerHeight;

        // Sold out quickviews will have no trigger button
        this.triggerButton = this.quickviewHolder.querySelector(`[${selectors$Q.dataPopup}${this.modalID}]`);
        this.handle = this.triggerButton ? this.triggerButton.getAttribute(`${selectors$Q.dataPopup}${this.modalID}`) : null;

        if (this.modalTemplate && !this.modal) {
          const modalTemplateInner = this.modalTemplate.innerHTML;
          const htmlObject = document.createElement('div');
          htmlObject.innerHTML = modalTemplateInner;
          this.modalHtml = htmlObject.querySelector(selectors$Q.quickviewModal);
          document.body.appendChild(this.modalHtml);
          this.modal = document.querySelector(selectors$Q.quickviewModal);
        }

        if (this.modalTemplate && this.triggerButton) {
          this.triggerButton.addEventListener('click', this.clickQuickviewEvent);
        }
      }
    }

    clickQuickviewButton(e) {
      e.preventDefault();

      if (this.modal && this.modalID) {
        // Reset modal ID before html content is loaded
        this.modal.id = this.modalID;
      }

      if (document.documentElement.hasAttribute('data-scroll-locked')) {
        this.scrollLockEnable = false;
      }

      this.container.classList.add(classes$BQ.loading);

      this.getQuickviewHTML();
    }

    getQuickviewHTML() {
      window
        .fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-bundle-product-quickview`)
        .then(this.handleErrors)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const fresh = document.createElement('div');
          fresh.innerHTML = response;
          this.modalContent = this.modal.querySelector(selectors$Q.modalContent);
          this.modalContent.innerHTML = fresh.querySelector('[data-api-contentt]').innerHTML;
          this.modalScroll = this.modal.querySelector(selectors$Q.quickviewModalScrolls);
          const images = this.modalContent.querySelector(selectors$Q.mediaId);
          var options = {
                    dots: false,
                    infinite: false,
                    autoplay: false,
                    speed: 800,
                    arrows: true,
                    variableWidth: false,
                    centerMode: false,
                    slidesToShow: 1,
                    asNavFor: '.slider-thumb',
                    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
                    nextArrow: '<button class="slide-arrow next-arrow"></button>'
                  }
          var thumbs = {
                    slidesToShow: 7,
                    slidesToScroll: 1,
                   infinite: false,
                    asNavFor: '.calendar-select',
                    dots: false,
                    variableWidth: false,
                    centerMode: false,
                    focusOnSelect: true,
                    responsive: [   
                          {
                              breakpoint: 768,
                              settings: {
                                 slidesToShow: 5,
                              }
                          }
                      ]
                  }
          
          if (images) {
            const imagesHolder = document.createElement('div');
            imagesHolder.innerHTML = images.parentElement.innerHTML;
            this.quickviewHolder.dispatchEvent(
              new CustomEvent('theme:quickview:media', {
                bubbles: true,
                detail: {
                  media: imagesHolder,
                },
              }),
            
                 
            );

           

             
          }

          this.modalCreate();
          this.container.classList.remove(classes$BQ.loading);
           
                $('.calendar-select').slick(options);
                $('.slider-thumb').slick(thumbs);
           if ($('.calendar-select').hasClass('slick-initialized')) {
                $('.calendar-select').slick('refresh'); 
                $('.slider-thumb').slick('refresh'); 
           }
        });
    }

    modalCreate() {
      MicroModal.show(this.modalID, {
        onShow: (modal, el, event) => {
          this.quickviewHead = modal.querySelector(selectors$Q.quickviewHead);
          this.quickviewFormArea = modal.querySelector(selectors$Q.quickviewFormArea);
          this.toggleButton = modal.querySelector(selectors$Q.toggleButton);

          this.toggleForm('loading');
          document.addEventListener(
            'theme:resize',
            throttle(() => {
              this.toggleForm('resize');
            }, 500)
          );

          this.clickEventToggleForm();

          const firstFocus = modal.querySelector(selectors$Q.focusable);
          trapFocus(modal, {elementToFocus: firstFocus});
          this.modal.addEventListener('theme:quickview:close', this.modalCloseEvent);

          // Attach .quickSelct handler when modal opens
          $(modal).on('click', '.quickSelct', function(e){
            e.preventDefault();

            // Get variant from the quickview form
            var quickviewForm = $(this).closest('.bundle_quick_form').find('form')[0];
            var variant = null;
            if (quickviewForm) {
              var productJson = quickviewForm.querySelector('[data-product-json]');
              if (productJson) {
                try {
                  var product = JSON.parse(productJson.textContent);
                  var selectedVariantId = quickviewForm.querySelector('[name="id"]').value;
                  variant = product.variants.find(function(v) { return v.id == selectedVariantId; });
                } catch(err) {
                  console.error('Bundle Set Debug: Error parsing product JSON:', err);
                }
              }
            }

            if (!variant) {
              console.error('Bundle Set Debug: Variant not found! Cannot proceed.');
              return;
            }

            $('li.product-bundle-item.item_wrp.active').addClass('nextClicked');
            var selectedVariantId = variant.id;
            var variantPrice = variant.price;
            var variantComparePrice = variant.compare_at_price;
             if(variant.featured_media){
              var variantImage = variant.featured_media.preview_image.src;
            }
            var prcConvert = (parseFloat(variantPrice)/100).toFixed(2);
            var comparePrcConvert = (parseFloat(variantComparePrice)/100).toFixed(2);
            var mainProductId = parseInt($('li.product-bundle-item.item_wrp.active .product-bundle-item__image').attr('data-mainpdpid'));
            var quickViewId = parseInt($(this).attr('data-main-pdp'));
              // console.log(prcConvert+ "convert");
            // console.log(mainProductId);
             $('.ck_sel_variant option').each(function(){

                 var val = $(this).val();
                 var idget = $(this).closest('.ck_sel_variant').attr('id');
                 var splitted = idget.split('-');
                 var mySelectId = parseInt(splitted[1]);

         var eachOption =variant.options;
         var selectedOption = eachOption.join(", ");
                    if (quickViewId === mainProductId && mainProductId === mySelectId) {
                      if(selectedVariantId == val){

                          $(this).prop("selected", "selected");
                          $('li.product-bundle-item.item_wrp.active .sel_variant_txt').html(selectedOption);

                         if(variantImage){
                            $('li.product-bundle-item.item_wrp.active .setp_bg img').attr('src' , variantImage);
                          }
                          $("li.product-bundle-item.item_wrp.active .wrp_title_pop span.price_hidden").attr("data-id", prcConvert);
                          $("li.product-bundle-item.item_wrp.active .wrp_title_pop span.price_hidden").attr("data-cprc", comparePrcConvert);


                             var total = 0;
                            var originaltotal = 0;
                               $('.item_wrp').each(function(idx){
                                  var totalPc =parseFloat($(this).find('.product-bundle-item__content span').attr('data-id'));
                                   // total+= totalPc;
                                   // console.log(totalPc);
                                  var totalCc =parseFloat($(this).find('.product-bundle-item__content span').attr('data-cprc'));
                                  total+= totalCc;
                                  originaltotal+= totalPc;
                             });

                              $('.total_all_pdp span').text('£'+total.toFixed(2));
                              $('.tot_item_price').text('£'+total.toFixed(2));

                        if(total > originaltotal){
                             document.querySelector(".bundle_saving_prc").innerHTML = '£'+originaltotal.toFixed(2);
                             document.querySelector(".bundle_saving_prc_crt").innerHTML = '£'+originaltotal.toFixed(2);
                        }


                        // console.log($('#'+quickViewId));

                        $('#'+quickViewId).find(' button.drawer__button.drawer__close').trigger('click');


                           return false;
                      }
                     }
                 });

              });
          
            document.querySelectorAll('[data-popup-size-chart]').forEach(button => {
            button.addEventListener('click', function () {
              const modalId = button.getAttribute('data-popup-size-chart');
              const modalTitle = button.getAttribute('data-modal-title') || 'Size Chart';
              const modalContent = button.getAttribute('data-modal-content') || '';
        
              // Remove existing
              const existing = document.getElementById(modalId);
              if (existing) existing.remove();
        
              // Inject modal HTML
              const modalHTML = `
                <div class="modal size-chart--fullscreen is-open" id="${modalId}" aria-hidden="false">
                  <div class="modal__overlay" data-micromodal-close></div>
                  <div class="modal__container" role="dialog" aria-modal="true" aria-label="${modalTitle}">
                    <button data-micromodal-close class="modal__close" aria-label="Close"></button>
                    <div class="rte">${modalContent}</div>
                  </div>
                </div>
              `;
              document.getElementById('global-size-chart-modal-container').innerHTML = modalHTML;
        
              // Close modal
              document.querySelectorAll('[data-micromodal-close]').forEach(closeBtn => {
                closeBtn.addEventListener('click', () => {
                  const modal = closeBtn.closest('.modal');
                  if (modal) modal.remove();
                });
              });
            });
          });

          $('body').addClass('scrolljjjj');
          // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.modalScroll}));

          new ImageCaption(this.modal);
        },
        onClose: (modal, el, event) => {
          const allMedia = modal.querySelectorAll(selectors$Q.media);

          allMedia.forEach((media) => {
            media.dispatchEvent(new CustomEvent('pause'));
          });

          

          removeTrapFocus();
          el.focus();
          this.modal.removeEventListener('theme:quickview:close', this.modalCloseEvent);
          if (this.scrollLockEnable) {
            // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
            $('body').removeClass('scrolljjjj');
            
            var hasDiv = $('li.product-bundle-item.item_wrp.active.nextClicked .next_step');
            if(hasDiv.length > 0){
             setTimeout(function(){
                   $('li.product-bundle-item.item_wrp.nextClicked').removeClass('nextClicked');
                    $('li.product-bundle-item.item_wrp.active .next_step').trigger('click');
             },800);
            }
            
          } else {
            this.scrollLockEnable = true;
          }
        },
      });
    }

    modalClose() {
      MicroModal.close(this.modalID);
      
    }

    handleErrors(response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          const e = new FetchError({
            status: response.statusText,
            headers: response.headers,
            json: json,
          });
          throw e;
        });
      }
      return response;
    }

    toggleForm(event) {
      if (this.windowH === window.innerHeight && event === 'resize') {
        return;
      }

      if (!this.toggleButton.classList.contains(classes$BQ.hide)) {
        this.toggleButton.classList.add(classes$BQ.hide);
      }

      if (!this.quickviewFormArea.classList.contains(classes$BQ.expanded)) {
        this.quickviewFormArea.classList.add(classes$BQ.expanded);
      }

      if (event === 'resize') {
        this.quickviewFormArea.classList.add(classes$BQ.expanded);
        this.toggleButton.classList.add(classes$BQ.hide);
        this.windowH = window.innerHeight;
      }

      setTimeout(() => {
        const imagesVisiblePartOfImages = window.innerHeight - this.quickviewHead.offsetHeight - this.quickviewFormArea.offsetHeight;
        const hasMediumVisiblePart = imagesVisiblePartOfImages < QvisibleParts.mediumPart && imagesVisiblePartOfImages > QvisibleParts.minPart;
        const missingVisiblePart = imagesVisiblePartOfImages < QvisibleParts.minPart;

        if (hasMediumVisiblePart || missingVisiblePart) {
          this.toggleButton.classList.remove(classes$BQ.hide);
          this.toggleButton.classList.add(classes$BQ.active);
        } else {
          this.toggleButton.classList.add(classes$BQ.hide);
        }

        if (missingVisiblePart) {
          if (event === 'loading') {
            this.quickviewFormArea.classList.add(classes$BQ.loading);

            setTimeout(() => {
              this.quickviewFormArea.classList.remove(classes$BQ.loading);
            }, 50);
          }

          // this.quickviewFormArea.classList.remove(classes$BQ.expanded);
          this.toggleButton.classList.remove(classes$BQ.active);
        } else {
          this.quickviewFormArea.classList.add(classes$BQ.expanded);
        }
      }, 200);
    }

    clickEventToggleForm() {
      if (!this.toggleButton) return;

      this.toggleButton.addEventListener('click', () => {
        this.toggleButton.classList.toggle(classes$BQ.active);
        this.quickviewFormArea.classList.toggle(classes$BQ.expanded);
      });
    }

    disconnectedCallback() {
      if (this.modalTemplate && this.triggerButton) {
        this.triggerButton.removeEventListener('click', this.clickQuickviewEvent);
      }
    }
}


if (!customElements.get('')) {
  customElements.define('bundle-product-quickview', BundleProductQuickView);
}





